import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300/60 bg-primary-100/50 text-primary-800 text-xs font-medium mb-4">
            Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            Popular Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Browse all 14 categories in the <strong>AllChinaBuy Spreadsheet</strong> — from sneakers and streetwear to accessories and more. Find the <strong>latest allchinabuy spreadsheet</strong> links for every category.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 rounded-xl p-4 md:p-5 hover:bg-primary-500 transition-all duration-300 cursor-pointer border border-background-200/60 flex flex-col items-center text-center"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-background-50 text-primary-500 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-xs md:text-sm font-heading font-semibold text-foreground-900 group-hover:text-background-50 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-[10px] md:text-xs text-foreground-400 group-hover:text-background-200 transition-colors mt-1 leading-tight hidden sm:block">
                {cat.description}
              </p>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            View All Products
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}